export default __webpack_public_path__ + "static/portfolio-mas-15-774ffbdd59da3daeef85481ae4d0400c.jpg";